var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPdfRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1.33301L6.5 1.33301C5.76667 1.33301 5.16667 1.93301 5.16667 2.66634V10.6663C5.16667 11.3997 5.76667 11.9997 6.5 11.9997H14.5C15.2333 11.9997 15.8333 11.3997 15.8333 10.6663V2.66634C15.8333 1.93301 15.2333 1.33301 14.5 1.33301ZM8.83333 6.33301C8.83333 6.88634 8.38667 7.33301 7.83333 7.33301H7.16667L7.16667 8.66634H6.16667V4.66634H7.83333C8.38667 4.66634 8.83333 5.11301 8.83333 5.66634V6.33301ZM12.1667 7.66634C12.1667 8.21967 11.72 8.66634 11.1667 8.66634H9.5V4.66634H11.1667C11.72 4.66634 12.1667 5.11301 12.1667 5.66634V7.66634ZM14.8333 5.66634H13.8333V6.33301H14.8333V7.33301H13.8333V8.66634H12.8333V4.66634L14.8333 4.66634V5.66634ZM7.16667 6.33301H7.83333V5.66634H7.16667V6.33301ZM3.83333 3.99967H2.5L2.5 13.333C2.5 14.0663 3.1 14.6663 3.83333 14.6663H13.1667V13.333H3.83333L3.83333 3.99967ZM10.5 7.66634H11.1667V5.66634H10.5V7.66634Z",
    fill: "#FF6666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdfRed);
export default __webpack_public_path__ + "static/media/IconPDFRed.55b90af43a8241051054ebbcf67d357d.svg";
export { ForwardRef as ReactComponent };